'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _alignments = require('../../../constants/alignments');

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _tooltip = require('../../tooltip2');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _getTooltip = require('../../../helpers/getTooltip');

var _getTooltip2 = _interopRequireDefault(_getTooltip);

var _primaryButton = require('../../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _sizes = require('../../../constants/sizes');

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _isDesktop = require('../../../helpers/isDesktop');

var _isDesktop2 = _interopRequireDefault(_isDesktop);

var _getScreenSize = require('../../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _customPlaceAutocomplete = require('../../../molecules/customPlaceAutocomplete');

var _customPlaceAutocomplete2 = _interopRequireDefault(_customPlaceAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonColumn = (0, _styledComponents2.default)(_column2.default)(_templateObject, function (_ref) {
    var desktop = _ref.desktop;
    return desktop && 'margin-left: 30px;';
});

var FormCustomPlaceAutocomplete = function FormCustomPlaceAutocomplete(_ref2) {
    var querryCode = _ref2.querryCode,
        label = _ref2.label,
        pageCode = _ref2.pageCode,
        sectionCode = _ref2.sectionCode,
        fieldCode = _ref2.fieldCode,
        editing = _ref2.editing,
        allowEdit = _ref2.allowEdit,
        context = _ref2.context,
        tooltipInfo = _ref2.tooltipInfo,
        saveTooltipInfo = _ref2.saveTooltipInfo,
        reduceTooltipInfoElement = _ref2.reduceTooltipInfoElement,
        handleClickApply = _ref2.handleClickApply;

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        option = _useState2[0],
        setOption = _useState2[1];

    var desktop = (0, _isDesktop2.default)((0, _getScreenSize2.default)());

    if (!(editing && allowEdit)) return null;

    var handleApply = function handleApply() {
        handleClickApply(option);
        setOption(null);
    };

    return _react2.default.createElement(
        _grid2.default,
        null,
        _react2.default.createElement(
            _row2.default,
            null,
            _react2.default.createElement(
                _column2.default,
                { xs: 5,
                    nogutter: true
                },
                _react2.default.createElement(
                    _container2.default,
                    { inline: true,
                        verticalAlignment: _alignments.Alignments.center
                    },
                    _react2.default.createElement(_label2.default, { bold: true,
                        textAlign: _alignments.Alignments.left,
                        text: label
                    }),
                    pageCode && sectionCode && fieldCode && _react2.default.createElement(_tooltip2.default, {
                        header: label,
                        text: (0, _getTooltip2.default)(tooltipInfo, pageCode, sectionCode, fieldCode),
                        saveHandler: saveTooltipInfo,
                        reduceHandler: function reduceHandler() {
                            return function (value) {
                                reduceTooltipInfoElement({
                                    newTooltip: value,
                                    pageCode: pageCode,
                                    sectionCode: sectionCode,
                                    fieldCode: fieldCode
                                });
                            };
                        }
                    })
                )
            ),
            _react2.default.createElement(_column2.default, { xs: 1 }),
            _react2.default.createElement(
                _column2.default,
                { xs: desktop ? 4.5 : 6, nogutter: true },
                _react2.default.createElement(_customPlaceAutocomplete2.default, { code: querryCode,
                    selectedOption: option ? option.placeId : null,
                    handleOptionSelect: setOption,
                    context: context
                })
            ),
            !desktop && _react2.default.createElement(_column2.default, { xs: 6 }),
            _react2.default.createElement(
                ButtonColumn,
                { desktop: desktop,
                    xs: desktop ? 1 : 3,
                    nogutter: true
                },
                _react2.default.createElement(_primaryButton2.default, {
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FormComponents.apply' }),
                    size: _sizes.Sizes.sm,
                    top: !desktop && _sizes.Sizes.md,
                    clickEvent: handleApply
                })
            )
        )
    );
};

FormCustomPlaceAutocomplete.propTypes = {
    querryCode: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    pageCode: _propTypes2.default.string,
    sectionCode: _propTypes2.default.string,
    fieldCode: _propTypes2.default.string,
    editing: _propTypes2.default.bool,
    allowEdit: _propTypes2.default.bool,
    context: _propTypes2.default.object.isRequired,
    tooltipInfo: _propTypes2.default.object,
    saveTooltipInfo: _propTypes2.default.func,
    reduceTooltipInfoElement: _propTypes2.default.func,
    handleClickApply: _propTypes2.default.func
};

exports.default = FormCustomPlaceAutocomplete;